import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import "./LandingTrainerSection.css";

const TRAINER_FEATURES = [
  {
    icon: <QuizOutlinedIcon />,
    title: "Вопросы в видео или тексте",
    desc: "Загружайте видео-вопросы или формулируйте их текстом — участник отвечает прямо в мессенджере.",
  },
  {
    icon: <CheckCircleOutlineIcon />,
    title: "Мгновенная обратная связь",
    desc: "После каждого ответа бот показывает, правильно ли ответил сотрудник, и ведёт к следующему вопросу.",
  },
  {
    icon: <BarChartOutlinedIcon />,
    title: "Аналитика ответов",
    desc: "Смотрите, кто проходил тренажёр, сколько ответов дал и какой процент правильных — по каждому участнику.",
  },
];

export default function LandingTrainerSection() {
  return (
    <section className="landing-section landing-section--trainer">
      <div className="landing-container">
        <div className="landing-section__header">
          <span className="landing-trainer__badge">Новая возможность</span>
          <h2 className="landing-section__title">Тренажёр с проверкой ответов</h2>
          <p className="landing-section__desc">
            Создавайте обучающие тесты для команды: вопросы, варианты ответов и
            автоматическая проверка — в Telegram или MAX, без отдельной LMS.
          </p>
        </div>

        <div className="landing-trainer-grid">
          {TRAINER_FEATURES.map(({ icon, title, desc }) => (
            <article className="landing-trainer-card" key={title}>
              <div className="landing-trainer-card__icon">{icon}</div>
              <h3 className="landing-trainer-card__title">{title}</h3>
              <p className="landing-trainer-card__desc">{desc}</p>
            </article>
          ))}
        </div>

        <div className="landing-trainer-flow">
          <div className="landing-trainer-flow__step">
            <span className="landing-trainer-flow__num">1</span>
            <p>Укажите название и тему — откроется форма без сетки сценария</p>
          </div>
          <div className="landing-trainer-flow__step">
            <span className="landing-trainer-flow__num">2</span>
            <p>Отметьте правильные варианты ответа на каждом вопросе</p>
          </div>
          <div className="landing-trainer-flow__step">
            <span className="landing-trainer-flow__num">3</span>
            <p>Опубликуйте и делитесь ссылкой — команда проходит в боте</p>
          </div>
          <div className="landing-trainer-flow__step">
            <span className="landing-trainer-flow__num">4</span>
            <p>Анализируйте точность ответов каждого сотрудника</p>
          </div>
        </div>
      </div>
    </section>
  );
}
